import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { CalendarService } from 'app/main/plus/calendar/calendar.service';

@Component({
  selector: 'app-calendar-date-buttons',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './calendar-date-buttons.component.html',
  styleUrl: './calendar-date-buttons.component.scss'
})
export class CalendarDateButtonsComponent {
  private _calendarService = inject(CalendarService);

  navigateToPrevious() {
    this._calendarService.changeDateClicked.set('previous');
  }
  
  navigateToNext() {
    this._calendarService.changeDateClicked.set('next');
  }

  navigateToToday() {
    this._calendarService.changeDateClicked.set('today');
  }
}
